(function($){

	$(document).ready(function(){
		
		$(document).on('click','.single .entry-header .image-wrapper .featured-image.is-video', function(e){
			
			$featured_video = this.parentElement.querySelector('.featured-video');
			$featured_video.play();
			$(this).siblings('.play-icon').hide();
			$(this).hide();

		});

		$(document).on('click','.social-share__trigger',function(e){
			e.preventDefault();
			$(this).siblings('.social-share').slideToggle();
		});
	});
	
})(jQuery);


function copyLink(event, $this) {
	event.preventDefault();
	var url = $this.dataset.url;
	navigator.clipboard.writeText(url);
	alert('Link copied to clipboard');
}